// import React, { PureComponent } from 'react';
/* eslint-disable jsx-a11y/label-has-associated-control */
import { css } from 'emotion';
import React from 'react';
import { useTheme } from '../../../theme-context';

const ProgressIndicatorLinear = ({ percent }: { percent: number }) => {
    const { styles } = useTheme();

    return (
        <div>
            <div
                className={css({
                    backgroundColor: styles.colors['grey-02'].color,
                    width: '100%',
                    height: '4px',
                    overflow: 'hidden',
                })}
            >
                <div
                    className={css({
                        '@keyframes progressBar': {
                            '0%': {
                                width: '0%',
                            },
                            '100%': {
                                width: 'default',
                            },
                        },
                        height: '100%',
                        backgroundColor: styles.colors['ui-green-light'].color,
                        borderRadius: '0px 4px 4px 0px',
                        animation: 'progressBar 0.6s linear',
                        animationFillMode: 'both',
                        width: `${percent}%`,
                    })}
                />
            </div>
        </div>
    );
};

export default ProgressIndicatorLinear;
